exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-com[data-v-7fa6bc97]{width:100%;height:100%}\n", ""]);

// exports
